import { MotionGlobalConfig } from 'framer-motion'

export function installViewTransitionMotionGuard() {
	if (typeof document === 'undefined') return
	if (typeof document.startViewTransition !== 'function') return

	const original = document.startViewTransition.bind(document)
	document.startViewTransition = function (...args: Parameters<typeof original>) {
		MotionGlobalConfig.skipAnimations = true
		const transition = original(...args)
		const restore = () => {
			MotionGlobalConfig.skipAnimations = false
		}
		transition.finished.then(restore, restore)
		return transition
	}
}
